import ApiBase from 'Services/Api/ApiBase';

class StaffForms extends ApiBase {
    route = '/human-resources/staff-forms';
};

export default new StaffForms();
